import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Partial, find } from 'lodash';
import {
    BaseControl,
    Textbox,
    TextArea,
    ColumnaMaestra,
    Container,
    Custom,
    DateTimePicker,
    ModalSelect,
    Static
  } from '@app/shared';


  
@Injectable()
export class RestrictionDocumentFormService {
  constructor() {}

  /**
   * Formulario de tablas maestras dinamicas
   *
   * @returns {BaseControl<any>[]}
   * @memberof RestrictionDocumentFormService
   */
  getFieldsRestrictionDocument(
    templetesFomr: any,
    objectModel: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
        new Custom({
            key: 'serie',
            label: 'Serie',
            value: objectModel ? objectModel.serie ? objectModel.serie.id : null : null, 
            size: 'col-12 col-lg-12',
            template: templetesFomr['serie'],
            placeholder: 'Seleccione la serie',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'subserie',
            label: 'Subserie',
            size: 'col-12 col-lg-12',
            value: objectModel ? objectModel.subserie ? objectModel.subserie.id : null : null, 
            template: templetesFomr['subserie'],
            placeholder: 'Seleccione la subserie',
            validations: {
              validators: []
            },
            condictions: [
              {
                campoDepende: 'serie',
                siEs: 'Vacio',
                accion: 'Bloquear'
              }
            ]
          }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}


// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-restriction-document/shared/manage-restriction-document.form.service.ts